import React, { useEffect, useState } from 'react';
import SueItemUpdate from './_SueItemUpdate';
import { GeneralDataModel } from '../models/GeneralDataModel';
import { SimulatorModel } from '../models/SimulatorModel';
import moment from 'moment';
import { ManulApiModel } from '../models/ManulApiModel';
import "./_sues.css";
import { SuesModel } from '../models/SuesModel';
import { message } from 'antd';

type Props = {
    policyId?: string;
    policyData?: any;
    riderData?: any;
    ShowHidePopup?: Function;
    ClosePopup: Function;
    OnApprove?: Function;
    showMessagePopup?: Function;
    type?: string;
    messageTitle?: string;
    showAddTreatmentPopup: (type: number) => void;
    customerId?: string;
    cancelAddClaimPoopup: Function;
};
const AddClaimPopup = (props: Props) => {
    const generalModel: GeneralDataModel = new GeneralDataModel();
    const simulatorModel: SimulatorModel = new SimulatorModel();
    const manulApiModel: ManulApiModel = new ManulApiModel();
    const suesModel = new SuesModel();

    const [sueDataForPopUp, setSueDataForPopUp] = useState<any | null>(null)

    const [popUpTitle, setPopUpTitle] = useState<string>(props.messageTitle ? props.messageTitle : 'חדשה')
    const [creatorsList, setCreatorsList] = useState<any[]>([]);
    const [handlersList, setHandlersList] = useState<any[]>([]);
    const [sueStatuses, setSueStatuses] = useState<any[]>([]);
    const [sueTypes, setSueTypes] = useState<any[]>([]);
    const [sueActivityStatuses, setSueActivityStatuses] = useState<any[]>([]);
    const [sueApartmentTypes, setSueApartmentTypes] = useState<any[]>([]);
    const [usersOptions, setUsersOptions] = useState<any[]>([]);
    const [showForm, setShowForm] = useState<boolean>(false);
    const [garages, setGarages] = useState<any[]>([])

    const [policyData, setPolicyData] = useState<any>(props.policyData);

    const [gendersList, setGendersList] = useState<any[]>([]);
    const [insuranceCompanyList, setInsuranceCompanyList] = useState<any[]>([]);

    // dragg and drop
    const [isDragging, setIsDragging] = useState<boolean>(false);
    const [position, setPosition] = useState<any>({ x: 200, y: 120 })
    const [offset, setOffset] = useState<any>({ x: 0, y: 0 })

    const init = async () => {
        console.log('init', props);
        const creatorsList = localStorage.getItem('creatorsList');
        if (creatorsList) {
            const dataList = buildOptionsForSelect(JSON.parse(creatorsList), 'id', 'כל היוצרים');
            const newCreatorsList: any = [
                {
                    label: 'נוצר ע"י',
                    value: '-1'
                },
                {
                    label: 'יוזרים פעילים',
                    value: '0'
                },
                {
                    label: 'יוזרים לא פעילים',
                    value: '1'
                },
                {
                    label: 'כל היוזרים',
                    value: '2'
                },
                ...dataList
            ]
            setCreatorsList(newCreatorsList)
        }

        const handlersData = await generalModel.getClaimHandlers();
        if (handlersData) {
            setHandlersList(handlersData.map((h: any) => {
                return {
                    label: h.fullName,
                    value: h.id
                }
            }))
        }

        const sueTypesData = await suesModel.sueTypeGetAll();
        setSueTypes(sueTypesData.map((st: any) => {
            return {
                label: st.name,
                value: st.id.toString(),
                policyTypeId: st.policyTypeId
            }
        }));
        const sueStatusesData = await suesModel.sueStatusGetAll();
        setSueStatuses(sueStatusesData.map((st: any) => {
            return {
                label: st.name,
                value: st.id.toString()
            }
        }));
        const sueActivityStatusesData = await suesModel.sueActivityStatusGetAll();
        setSueActivityStatuses(sueActivityStatusesData.map((st: any) => {
            return {
                label: st.name,
                value: st.id.toString()
            }
        }));

        const usersData = await generalModel.customerCardGetCreators();
        setUsersOptions(usersData);

        const genderTypesData = await simulatorModel.getGenderTypes();
        const gendersList: any = [];
        Object.keys(genderTypesData).forEach((key: string) => {
            const gender = genderTypesData[key];
            gendersList.push({
                label: gender.description,
                value: gender.id.toString()
            })
        })
        console.log('getAppDictionaryList Genders', gendersList);
        setGendersList(gendersList);


        const insuranceCompaniesData = await simulatorModel.getInsuranceCompanies();
        const icTempDataKeys = Object.keys(insuranceCompaniesData);
        const fixedInsuranceCompanies: any[] = [];
        icTempDataKeys.forEach((k: string) => {
            fixedInsuranceCompanies.push({
                value: insuranceCompaniesData[k].description,
                label: insuranceCompaniesData[k].name,
                id: insuranceCompaniesData[k].description,
                name: insuranceCompaniesData[k].name,
            })
        });
        fixedInsuranceCompanies.sort((a: any, b: any) => (a.label > b.label) ? 1 : -1)
        await setInsuranceCompanyList(fixedInsuranceCompanies);

        // if (policyData && policyData.policyType && policyData.policyType.policyTypeId == 1) {
        //     try {
        //         const garagesData: any = await manulApiModel.GetGarages();
        //         if (garagesData) {
        //             setGarages(garagesData);
        //         }
        //     } catch (error) {

        //     }
        // }
        const garagesListString = localStorage.getItem('garagesData');
        if (!garagesListString) {
            try {
                const garagesData: any[] = await manulApiModel.GetGarages();
                console.log('init-garagesData await manulApiModel.GetGarages',  garagesData)
                if (garagesData) {
                    let moshahList: any[] = [];
                    moshahList = garagesData.map((g: any)=>{
                        return {
                            shem_mosah: g.shem_mosah,
                            id: g._id,
                            cod_miktzoa: g.cod_miktzoa,
                            cod_sug_mosah: g.cod_sug_mosah,
                            ktovet: g.ktovet,
                            menahel_miktzoa: g.menahel_miktzoa,
                            miktzoa: g.miktzoa,
                            mikud: g.mikud,
                            mispar_mosah: g.mispar_mosah,
                            rasham_havarot: g.rasham_havarot,
                            sug_mosah: g.sug_mosah,
                            telephone: g.telephone,
                            yishuv: g.yishuv
                        }
                    });
                    setGarages([...moshahList]);
                    localStorage.setItem('garagesData', JSON.stringify(moshahList));
                    
                }
            } catch (error) {
                console.log('error', error)
            }
        } else {

            const garagesData = JSON.parse(garagesListString);
            console.log('init-garagesData localStorage', garagesData)
            setGarages(garagesData);
            // console.log('garagesData', garagesData);
        }

        let sueData: any = {
            "sueNumber": undefined,
            "serialNumber": '0',
            "internalNumber": 0,
            "openingDate": moment().toDate(),
            "closingDate": undefined,
            "sueType": 4,
            "status": 0,
            "activityStatus": 0,
            "policyId": policyData && policyData.policyNumber ? policyData.id : null,
            "policy": policyData && policyData.policyNumber ? policyData : null,
            "riderId": policyData && policyData.productionDate ? policyData.id : null,
            "rider": policyData && policyData.productionDate ? policyData : null,
            "customerId": policyData && policyData.customerId ? policyData.customerId : undefined,
            "customer": policyData && policyData.customer ? policyData.customer : undefined,
            "handlerId": policyData && policyData.handler ? policyData.handler.id : undefined,
            "handler": policyData && policyData.handler ? policyData.handler : undefined,
            "insuranceCompanyId": policyData && policyData.insuranceCompanyId ? policyData.insuranceCompanyId : undefined,
            "insuranceCompany": policyData && policyData.insuranceCompany ? policyData.insuranceCompany : undefined,
            "damageAppraiser": 0,
            "impairment": 0,
            "deductible": 0,
            "impairmentPercent": 0,
            "appraiserAmount": 0,
            "establishmentValue": 0,
            "additionalExpenses": 0,
            "requestedAmount": null,
            "approvedAmount": null,
            "paymentDate": undefined,
            "comments": "",
            "vehicleId": policyData && policyData.vehicle ? policyData.vehicle.id : undefined,
            "vehicle": policyData && policyData.vehicle ? policyData.vehicle : undefined,
            "driverId": undefined,
            "driver": undefined,
            "seniorityDate": undefined,
            "sueAccidentAndDamageInfoId": undefined,
            "sueAccidentAndDamageInfo": undefined,
            "participant1Id": undefined,
            "participant1": undefined,
            // {
            //     "id": undefined,
            //     "name": '',
            //     "address": '',
            //     "age": 0,
            //     "phone": '',
            //     "hospitalName": ''
            // },
            "participant2Id": undefined,
            "participant3Id": undefined,
            "participant4Id": undefined,
            "participant5Id": undefined,
            "participant6Id": undefined,
            "sueWitness1Id": undefined,
            "sueWitness1": {
                "name": '',
                "address": '',
                "phone": '',
                "mobile": '',
                "relation": ''
            },
            "sueWitness2Id": undefined,
            "sueWitness2": {
                "name": '',
                "address": '',
                "phone": '',
                "mobile": '',
                "relation": ''
            },
            "involvedVehiclesId": undefined,
            "involvedVehicles": undefined,
            "involvedVehiclesList": [],
            "garageDetailsId": undefined,
            "garageDetails": {
                "id": undefined,
                "assessorName": '',
                "assessorPhoneNumber": '',
                "assessorMobilePhoneNumber": '',
                "assessorFaxNumber": '',
                "assessorAddress": '',
                "assessorEmail": '',
                "garageDetails": false,
                "garageName": '',
                "garagePhone": '',
                "garageFaxNumber": '',
                "garageAddress": '',
                "garageEmail": '',
                "garageIdentity": '',
                "garageContactPerson": ''
            },
            "branchId": undefined,
            "branch": undefined,
            "customerCheckMaturityDate": undefined,
            "documents": [],
            "treatments": [],
            "sueComments": [],
            "id": undefined,
            "createdDate": undefined,
            "updatedDate": undefined
        }

        console.log('AddClaimPopup-policyData', sueData)
        if (policyData.sueId) {
            let sueDataFromServer = await suesModel.suesGetById({ sueId: policyData.sueId });
            console.log('AddClaimPopup-sueDataFromServer', sueDataFromServer)
            if (sueDataFromServer) {
                sueData = sueDataFromServer;
                setSueDataForPopUp({...sueDataFromServer});//, vehicle: {...sueDataFromServer.vehicle}});
            }
        } else {

            setSueDataForPopUp(sueData)
        }


        await setShowForm(true);
    }

    const buildOptionsForSelect = (source: any[], param: string = 'id', label: string = 'הכל') => {
        const items: any[] = [];
        source.forEach((i: any) => {
            items.push(
                {
                    label: i.fullName,
                    value: i[param]
                }
            );
        })
        console.log('buildOptionsForSelect', items);
        return items;
    }

    const closePopup = (status?: string) => {
        if (props.ClosePopup) {
            props.ClosePopup(status);
        }
    }
    const showMessagePopup = (message: string) => {
        if (props.showMessagePopup) {
            props.showMessagePopup(message)
        }
    }


    const handleMouseDown = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
        console.log('handleMouseDown', e.clientX, e.clientY);
        setIsDragging(true);
        setOffset({
            x: e.clientX - position.x,
            y: e.clientY - position.y
        })
    }

    const handleMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
        console.log('handleMouseMove');
        if (isDragging) {
            setPosition({ x: e.clientX - offset.x, y: e.clientY - offset.y })
        }
    }

    const handleMouseUp = (): void => {
        console.log('handleMouseUp');
        setIsDragging(false);
    };

    const emptyFunc = () => { }

    useEffect(() => {
        init();
    }, [])

    return (
        <>
            {showForm && <div className={`popup-wrapper edit-policy-popup ${props.type}`}>
                <section className="popup-window rtl"
                    style={{ position: 'absolute', top: position.y, left: position.x }}>
                    {/* <div className="close-icon pointer" onClick={(e: any) => closePopup()}></div> */}
                    <div className="popup-content"

                    >
                        <div className="popup-header">
                            <div className="popup-title" style={{ cursor: isDragging ? 'grabbing' : 'grab', }}
                                onMouseDown={handleMouseDown}
                                onMouseMove={handleMouseMove}
                                onMouseUp={handleMouseUp}
                                onMouseLeave={handleMouseUp}>
                                תביעה {popUpTitle}
                            </div>
                        </div>
                        <div className="popup-body">

                            <SueItemUpdate
                                onRelaodAfterSaveSue={(data: any) => { closePopup() }}
                                isPopUp={true}
                                tabData={{
                                    type: 'addSue',
                                    id: props.policyId,
                                    title: 'ללא שם',
                                    loaded: true,
                                    sueData: sueDataForPopUp
                                }}
                                customerId={props.customerId ? props.customerId : (policyData && policyData.customerId ? policyData.customerId : '')}
                                config={{
                                    policyId: props.policyId,
                                    policyData: props.policyData,
                                    sueStatuses: sueStatuses,
                                    sueTypes: sueTypes,
                                    sueActivityStatuses: sueActivityStatuses,
                                    sueApartmentTypes: sueApartmentTypes,
                                    handlers: handlersList,
                                    genders: gendersList,
                                    insuranceCompanies: insuranceCompanyList,
                                    garages: garages,
                                    users: usersOptions,
                                    closeTab: () => closePopup(),
                                    showMessagePopup: (message: string) => showMessagePopup(message),
                                    showAddTreatmentPopup: props.showAddTreatmentPopup ? props.showAddTreatmentPopup : emptyFunc,
                                }}
                                cancelAddClaimPoopup={props.cancelAddClaimPoopup}
                            />
                        </div>

                    </div>
                </section>
            </div>}
        </>
    )
}
export default AddClaimPopup;